import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination,Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
export default function Contact() {
  const brands = [
    
    "/assets/img/kayak.png",
    "/assets/img/tripadvisor.png",
    "/assets/img/Tripadvisor_lockup_horizontal_secondary_registered.svg",
    "/assets/img/tripadvisor.png",
    "/assets/img/kayak.png",
    "/assets/img/tripadvisor.png",
    "/assets/img/Tripadvisor_lockup_horizontal_secondary_registered.svg",
    "/assets/img/tripadvisor.png",
    "/assets/img/kayak.png",
    "/assets/img/Tripadvisor_lockup_horizontal_secondary_registered.svg",
    "/assets/img/tripadvisor.png",
    "/assets/img/tripadvisor.png",
    "/assets/img/kayak.png",
    "/assets/img/Tripadvisor_lockup_horizontal_secondary_registered.svg",
  ];
  return (
    <>
      {/* <Header /> */}

      <IndiaBoatsTopBar />
      <PremiumNavbar />
      <>
  <div className="breadcumb-wrapper " style={{
    backgroundImage: "url(/assets/img/boat1.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}>
    <div className="container">
      <div className="breadcumb-content aboutus-text-bg">
        <h1 className="breadcumb-title">Contact Us</h1>
        {/* <ul class="breadcumb-menu">
              <li><a href="home-travel.html">Home</a></li>
              <li>About Tourm</li>
          </ul> */}
      </div>
    </div>
  </div>
  <div className="space">
    <div className="container">
      <div className="title-area text-center">
        <span className="sub-title">Get In Touch</span>
        <h2 className="sec-title">Our Contact Information</h2>
      </div>
      <div className="row gy-4 justify-content-center">
        <div className="col-xl-4 col-lg-6">
          <div className="about-contact-grid style2">
            <div className="about-contact-icon">
              <img src="assets/img/icon/location-dot2.svg" alt="" />
            </div>
            <div className="about-contact-details">
              <h6 className="box-title">Our Address</h6>
              <p className="about-contact-details-text">
                803, Hubtown Viva, Western Express Highway, Jogeshwari East,
                Mumbai - 400060, INDIA
              </p>
              {/* <p class="about-contact-details-text">Road, New York, Canada</p> */}
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-6">
          <div className="about-contact-grid">
            <div className="about-contact-icon">
              <img src="assets/img/icon/call.svg" alt="" />
            </div>
            <div className="about-contact-details">
              <h6 className="box-title">Phone Number</h6>
              <p className="about-contact-details-text">
                <a href="tel:+91 8591993301">+91 8591993301</a>
              </p>
              <p className="about-contact-details-text">
                <a href="tel:+91 8591983301">+91 8591983301</a>
              </p>
              <p className="about-contact-details-text">
                <a href="tel:022 66958111">022 66958111</a>
              </p>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-6">
          <div className="about-contact-grid">
            <div className="about-contact-icon">
              <img src="assets/img/icon/mail.svg" alt="" />
            </div>
            <div className="about-contact-details">
              <h6 className="box-title">Email Address</h6>
              <p className="about-contact-details-text">
                <a href="mailto:customercare@indiaboats.in">
                  customercare@indiaboats.in
                </a>
              </p>
              <p className="about-contact-details-text">
                <a href="https://www.indiaboats.in ">
                  https://www.indiaboats.in
                </a>
              </p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    className="space-extra2-top space-extra2-bottom"
    data-bg-src="assets/img/bg/video_bg_1.jpg"
  >
    
  </div>
  <div className="">
    <div className="container-fluid">
      <div className="contact-map style2">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d942.364116126432!2d72.85475489841414!3d19.13148638074633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c82decc82e0d%3A0x3435fb136000746a!2sIndia%20Boats!5e0!3m2!1sen!2sin!4v1733493620082!5m2!1sen!2sin"
          width={600}
          height={450}
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  </div>


  {/* <section className="testi-area overflow-hidden space" id="testi-sec">
      <div className="container-fluid p-0">
        <div className="title-area mb-20 text-center">
          <span className="sub-title">Testimonial</span>
          <h2 className="sec-title">What Client Say About us</h2>
        </div>

        <Swiper
         
          modules={[Pagination,Autoplay]}
          spaceBetween={20}
          centeredSlides={true}          
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            767: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
          className="testiSlider1"
        >
          
          <SwiperSlide>
            <div className="testi-card">
              <div className="testi-card_wrapper">
                <div className="testi-card_profile">
                  <div className="testi-card_avater"></div>
                  <div className="media-body">
                    <h3 className="box-title">Maria Doe</h3>
                    <span className="testi-card_desig">Traveller</span>
                  </div>
                </div>
                <div className="testi-card_review">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star" />
                  ))}
                </div>
              </div>
              <p className="testi-card_text">
                “A home that perfectly blends sustainability with luxury...”
              </p>
              <div className="testi-card-quote">
                <img src="/assets/img/icon/testi-quote.svg" alt="img" />
              </div>
            </div>
          </SwiperSlide>

          
          <SwiperSlide>
            <div className="testi-card">
              <div className="testi-card_wrapper">
                <div className="testi-card_profile">
                  <div className="testi-card_avater"></div>
                  <div className="media-body">
                    <h3 className="box-title">Andrew Simon</h3>
                    <span className="testi-card_desig">Traveller</span>
                  </div>
                </div>
                <div className="testi-card_review">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star" />
                  ))}
                </div>
              </div>
              <p className="testi-card_text">
                “The home boasts sleek, contemporary architecture...”
              </p>
              <div className="testi-card-quote">
                <img src="/assets/img/icon/testi-quote.svg" alt="img" />
              </div>
            </div>
          </SwiperSlide>
<SwiperSlide>
            <div className="testi-card">
              <div className="testi-card_wrapper">
                <div className="testi-card_profile">
                  <div className="testi-card_avater"></div>
                  <div className="media-body">
                    <h3 className="box-title">Maria Doe</h3>
                    <span className="testi-card_desig">Traveller</span>
                  </div>
                </div>
                <div className="testi-card_review">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star" />
                  ))}
                </div>
              </div>
              <p className="testi-card_text">
                “A home that perfectly blends sustainability with luxury...”
              </p>
              <div className="testi-card-quote">
                <img src="/assets/img/icon/testi-quote.svg" alt="img" />
              </div>
            </div>
          </SwiperSlide>
<SwiperSlide>
            <div className="testi-card">
              <div className="testi-card_wrapper">
                <div className="testi-card_profile">
                  <div className="testi-card_avater"></div>
                  <div className="media-body">
                    <h3 className="box-title">Andrew Simon</h3>
                    <span className="testi-card_desig">Traveller</span>
                  </div>
                </div>
                <div className="testi-card_review">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star" />
                  ))}
                </div>
              </div>
              <p className="testi-card_text">
                “The home boasts sleek, contemporary architecture...”
              </p>
              <div className="testi-card-quote">
                <img src="/assets/img/icon/testi-quote.svg" alt="img" />
              </div>
            </div>
          </SwiperSlide>
<SwiperSlide>
            <div className="testi-card">
              <div className="testi-card_wrapper">
                <div className="testi-card_profile">
                  <div className="testi-card_avater"></div>
                  <div className="media-body">
                    <h3 className="box-title">Maria Doe</h3>
                    <span className="testi-card_desig">Traveller</span>
                  </div>
                </div>
                <div className="testi-card_review">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star" />
                  ))}
                </div>
              </div>
              <p className="testi-card_text">
                “A home that perfectly blends sustainability with luxury...”
              </p>
              <div className="testi-card-quote">
                <img src="/assets/img/icon/testi-quote.svg" alt="img" />
              </div>
            </div>
          </SwiperSlide>

        </Swiper>
      </div>

      
      <div className="shape-mockup d-none d-xl-block">
        <img src="/assets/img/shape/line2.png" alt="shape" />
      </div>

      <div className="shape-mockup movingX d-none d-xl-block">
        <img src="/assets/img/shape/shape_7.png" alt="shape" />
      </div>
      <div className="shape-mockup movingX d-none d-xl-block">
        <img src="/assets/img/shape/shape_7.png" alt="shape" />
      </div>
    </section> */}
  {/*==============================
Brand Area  
==============================*/}
  <div className="brand-area overflow-hidden space-bottom">
      <div className="container th-container">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 6 },
            1400: { slidesPerView: 8 },
          }}
          className="brandSlider1"
        >
          {brands.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="d-flex align-items-center justify-content-center height-100">
                <a href="#">
                  <img
                    className="gray"
                    src={img}
                    alt="Brand Logo"
                    style={{ maxHeight: "60px", objectFit: "contain" }}
                  />
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
</>

      <Footer />
    </>
  );
}
